import {
  discoveryApiRef,
  fetchApiRef,
  githubAuthApiRef,
  useApiHolder,
} from '@backstage/core-plugin-api';
import { useEffect, useState } from 'react';

import { AsdpApi } from './asdpApi';

const APPLICATION_PORTAL_PLUGIN_ID = 'application-portal';
const GITHUB_SCOPES = ['repo'];

/**
 * The backend's `/asdp` routes as the signed-in person. `optional` never
 * prompts a GitHub sign-in (the nav badge): calls fail quietly instead.
 */
export const useAsdpApi = ({ optional = false } = {}) => {
  const apis = useApiHolder();
  const discoveryApi = apis.get(discoveryApiRef);
  const fetchApi = apis.get(fetchApiRef);
  const githubAuth = apis.get(githubAuthApiRef);
  const [api, setApi] = useState<AsdpApi>();

  useEffect(() => {
    if (!discoveryApi || !fetchApi || !githubAuth) return undefined;
    let mounted = true;
    void discoveryApi.getBaseUrl(APPLICATION_PORTAL_PLUGIN_ID).then(baseUrl => {
      if (!mounted) return;
      setApi(
        new AsdpApi(baseUrl, fetchApi, async () => {
          const token = await githubAuth.getAccessToken(GITHUB_SCOPES, {
            optional,
          });
          if (!token) throw new Error('Not signed in to GitHub.');
          return token;
        }),
      );
    });
    return () => {
      mounted = false;
    };
  }, [discoveryApi, fetchApi, githubAuth, optional]);

  return api;
};
